export default __webpack_public_path__ + "static/media/pic111.4078e0ce.jpg";